var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_11527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 0H0V146H146V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5291 22.7899C62.5291 22.7899 23.5046 24.4858 21.2904 58.8071C19.0762 93.1284 8.83577 125.784 33.745 127.733C58.6543 129.682 117.053 133.469 125.356 113.022C133.659 92.5746 137.81 15.5899 62.5291 22.7899Z",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0427 75.2913C81.9087 68.7951 74.0018 60.4958 67.417 56.7908L67.501 56.6416C74.1117 60.3612 82.0499 68.694 85.1968 75.2168L85.0427 75.2913Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5957 55.0813L57.6078 54.9105C61.5255 55.1852 65.4317 53.4686 69.2175 49.8087C71.9935 47.125 74.6415 43.4784 77.0879 38.9697L77.2384 39.0515C74.7836 43.5753 72.1251 47.236 69.3366 49.9318C65.5143 53.6269 61.5641 55.3595 57.5957 55.0813Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6182 54.6273L93.6214 54.4561C101.033 54.5939 107.362 59.1444 111.366 62.9375L111.248 63.0618C107.266 59.2895 100.975 54.7641 93.6182 54.6273Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2887 116.885C20.1154 117.012 18.3389 115.493 18.3389 113.498V41.5985C18.3389 39.6036 20.1154 38.0451 22.2887 38.124L124.873 41.8464C126.535 41.9067 127.881 43.3658 127.881 45.0991V107.573C127.881 109.306 126.535 110.795 124.873 110.892L22.2887 116.885Z",
    fill: "url(#paint0_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1693 124.844C87.5296 124.274 86.3041 122.814 85.9585 121.019L83.5721 108.627L63.1576 109.388L60.6452 122.297C60.2934 124.105 61.7019 125.919 63.3241 126.585L71.8651 130.091C73.4536 130.743 75.1612 131.003 76.8584 130.851L94.9085 129.231C95.4361 129.183 95.8594 128.748 95.9208 128.19C95.9822 127.632 96.3519 127.005 95.8487 126.83L89.1693 124.844Z",
    fill: "url(#paint1_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3705 124.091C87.7325 123.527 86.5082 122.085 86.163 120.314L83.7789 108.077L63.8621 108.829L61.3522 121.577C61.0007 123.362 61.9308 125.152 63.5513 125.81L72.0837 129.272C73.6706 129.916 75.3765 130.172 77.0719 130.022L95.1039 128.422C95.631 128.375 96.0538 127.945 96.1152 127.394C96.1765 126.843 95.8594 126.323 95.3567 126.15L89.3705 124.091Z",
    fill: "url(#paint2_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1002 116.885C20.9269 117.012 19.1504 115.493 19.1504 113.498V41.5985C19.1504 39.6036 20.9269 38.0451 23.1002 38.124L125.684 41.8464C127.346 41.9067 128.693 43.3658 128.693 45.0991V107.573C128.693 109.306 127.346 110.795 125.684 110.892L23.1002 116.885Z",
    fill: "url(#paint3_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.685 43.315L23.1006 39.7992C21.9385 39.7594 20.9941 40.5909 20.9941 41.6565V97.5959V113.398C20.9941 114.463 21.9386 115.274 23.1006 115.208L125.685 109.422C126.575 109.371 127.296 108.577 127.296 107.647V93.3699V45.0536C127.296 44.1239 126.575 43.3455 125.685 43.315Z",
    fill: "url(#paint4_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1002 109.096C22.6477 109.118 22.2793 108.799 22.2793 108.384V41.6981C22.2793 41.2835 22.6477 40.9583 23.1002 40.9731L125.684 44.3441C126.032 44.3555 126.314 44.6601 126.314 45.0228V103.374C126.314 103.737 126.032 104.046 125.684 104.063L23.1002 109.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.004 49.0847C115.004 49.3746 114.776 49.6039 114.494 49.5967C114.212 49.5896 113.983 49.3484 113.983 49.0581C113.983 48.7678 114.212 48.5386 114.494 48.5461C114.776 48.5536 115.004 48.7948 115.004 49.0847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.097 49.1397C117.097 49.4288 116.87 49.6574 116.59 49.6503C116.31 49.6433 116.082 49.4028 116.082 49.1133C116.082 48.8238 116.31 48.5952 116.59 48.6027C116.87 48.6102 117.097 48.8506 117.097 49.1397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.179 49.1928C119.179 49.4811 118.954 49.7091 118.675 49.7021C118.396 49.695 118.17 49.4553 118.17 49.1666C118.17 48.8779 118.396 48.65 118.675 48.6574C118.954 48.6648 119.179 48.9045 119.179 49.1928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M121.179 64.8439L104.328 64.7645V53.7793L121.179 54.1054V64.8439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.179 66.8099L104.328 66.7757V65.9531L121.179 66.0058V66.8099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.909 68.198L104.328 68.1966V67.374L114.909 67.3871V68.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M121.179 80.595L104.328 80.8775V69.8923L121.179 69.8564V80.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.179 82.5628L104.328 82.8905V82.068L121.179 81.7588V82.5628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.909 84.0854L104.328 84.3112V83.4886L114.909 83.2744V84.0854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M121.179 96.3499L104.328 96.9942V86.009L121.179 85.6113V96.3499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.179 98.3168L104.328 99.0064V98.1838L121.179 97.5127V98.3168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.909 99.9741L104.328 100.427V99.6045L114.909 99.1631V99.9741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.045 96.1972L95.7998 96.4661V93.9342L103.045 93.6895V96.1972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6809 96.5073L87.2725 96.7823V94.2219L94.6809 93.9717V96.5073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5718 123.934L25.0928 123.433C24.329 122.632 24.39 121.373 25.2293 120.621L58.1339 91.1719L61.1376 94.5878L28.4591 124.018C27.6257 124.768 26.3332 124.732 25.5718 123.934Z",
    fill: "url(#paint5_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2392 62.7846C82.9398 52.569 68.2228 50.9195 58.3851 59.456C48.3668 68.1492 47.5589 83.7482 56.5505 93.9281C65.331 103.869 79.9818 104.633 89.3092 95.9818C98.4754 87.4806 99.3498 72.7679 91.2392 62.7846ZM59.4118 91.3593C51.9234 82.8229 52.6071 69.785 60.9596 62.4969C69.1858 55.3188 81.5411 56.6437 88.5426 65.2056C95.4098 73.6033 94.6793 86.016 86.9276 93.1689C79.0612 100.428 66.7526 99.7274 59.4118 91.3593Z",
    fill: "url(#paint6_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.1339 91.1719L53.9384 94.9268C54.3261 96.6407 54.0884 97.8359 53.6847 98.684C52.1658 101.875 47.8353 101.172 44.3505 105.704C42.6019 107.978 43.3956 108.541 41.6227 110.384C38.6918 113.431 36.1629 112.267 33.5853 114.998C30.978 117.761 31.9442 120.671 30.0831 121.413C29.287 121.731 28.0254 121.63 25.9174 120.006L25.2293 120.621C24.39 121.373 24.329 122.632 25.0928 123.433L25.5718 123.934C26.3332 124.732 27.6257 124.768 28.459 124.018L61.1375 94.5878L58.1339 91.1719Z",
    fill: "url(#paint7_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4423 63.4321C84.1429 53.2165 69.4259 51.567 59.5882 60.1035C49.57 68.7967 48.762 84.3957 57.7536 94.5757C66.5341 104.517 81.1849 105.28 90.5124 96.6294C99.6786 88.128 100.553 73.4154 92.4423 63.4321ZM60.6149 92.0067C53.1266 83.4703 53.8102 70.4325 62.1627 63.1443C70.389 55.9663 82.7443 57.2911 89.7458 65.853C96.613 74.2507 95.8825 86.6635 88.1308 93.8163C80.2643 101.075 67.9558 100.375 60.6149 92.0067Z",
    fill: "url(#paint8_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4898 64.2871C83.648 54.657 69.7665 53.1251 60.5003 61.1815C51.0739 69.3772 50.3096 84.0677 58.7668 93.6658C67.0367 103.051 80.8593 103.795 89.6714 95.6368C98.3397 87.6118 99.163 73.7102 91.4898 64.2871ZM60.6144 92.0069C53.1261 83.4706 53.8098 70.4327 62.1622 63.1446C70.3885 55.9665 82.7438 57.2913 89.7453 65.8533C96.6125 74.2509 95.882 86.6637 88.1303 93.8165C80.2638 101.075 67.9553 100.375 60.6144 92.0069Z",
    fill: "url(#paint9_linear_586_11527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.976 88.4782C111.993 88.6739 111.852 88.8359 111.662 88.8401C111.471 88.8442 111.303 88.6887 111.287 88.4928C111.27 88.2968 111.41 88.1349 111.601 88.1309C111.791 88.127 111.959 88.2825 111.976 88.4782Z",
    fill: "url(#paint10_linear_586_11527)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_586_11527",
    x1: 29.7848,
    y1: 79.0639,
    x2: 47.9767,
    y2: 77.1632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#26264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444B8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_586_11527",
    x1: 68.5642,
    y1: 134.642,
    x2: 72.4185,
    y2: 129.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_586_11527",
    x1: 80.2311,
    y1: 133.226,
    x2: 74.3322,
    y2: 101.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_586_11527",
    x1: 94.7831,
    y1: 44.8246,
    x2: 124.303,
    y2: 2.69257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_586_11527",
    x1: 81.962,
    y1: 49.8262,
    x2: 45.0362,
    y2: 167.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_586_11527",
    x1: 24.5576,
    y1: 107.865,
    x2: 61.1375,
    y2: 107.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_586_11527",
    x1: 50.3047,
    y1: 77.9659,
    x2: 96.7957,
    y2: 77.9659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_586_11527",
    x1: 24.5576,
    y1: 107.865,
    x2: 61.1375,
    y2: 107.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_586_11527",
    x1: 90.2054,
    y1: 98.9762,
    x2: 69.0286,
    y2: 71.0455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_586_11527",
    x1: 52.8945,
    y1: 78.6289,
    x2: 96.7486,
    y2: 78.6289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_586_11527",
    x1: 112.215,
    y1: 87.0699,
    x2: 88.7512,
    y2: 144.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_11527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 146,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.b7bee470d2550e746079d0adc1612ab8.svg";
export { ForwardRef as ReactComponent };